/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAdminMontageplanAffectedProjectDto } from '../models/work-admin-montageplan-affected-project-dto';
import { WorkAdminMontageplanClearRedisCacheResultDto } from '../models/work-admin-montageplan-clear-redis-cache-result-dto';
import { WorkAdminMontageplanRecalculateDto } from '../models/work-admin-montageplan-recalculate-dto';

@Injectable({ providedIn: 'root' })
export class WorkAdminMontageplanService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminMontageplanControllerClearRedisCache()` */
  static readonly AdminMontageplanControllerClearRedisCachePath = '/v2/admin/montageplan/redis-cache';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminMontageplanControllerClearRedisCache()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMontageplanControllerClearRedisCache$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkAdminMontageplanClearRedisCacheResultDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminMontageplanService.AdminMontageplanControllerClearRedisCachePath, 'delete');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkAdminMontageplanClearRedisCacheResultDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminMontageplanControllerClearRedisCache$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMontageplanControllerClearRedisCache(
    params?: {
    },
    context?: HttpContext
  ): Observable<WorkAdminMontageplanClearRedisCacheResultDto> {
    return this.adminMontageplanControllerClearRedisCache$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkAdminMontageplanClearRedisCacheResultDto>): WorkAdminMontageplanClearRedisCacheResultDto => r.body)
    );
  }

  /** Path part for operation `adminMontageplanControllerGetAffectedProjects()` */
  static readonly AdminMontageplanControllerGetAffectedProjectsPath = '/v2/admin/montageplan/affected-projects';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminMontageplanControllerGetAffectedProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMontageplanControllerGetAffectedProjects$Response(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkAdminMontageplanAffectedProjectDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminMontageplanService.AdminMontageplanControllerGetAffectedProjectsPath, 'get');
    if (params) {
      rb.query('dateFrom', params.dateFrom, {});
      rb.query('dateTo', params.dateTo, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkAdminMontageplanAffectedProjectDto>>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminMontageplanControllerGetAffectedProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  adminMontageplanControllerGetAffectedProjects(
    params: {
      dateFrom: string;
      dateTo: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkAdminMontageplanAffectedProjectDto>> {
    return this.adminMontageplanControllerGetAffectedProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkAdminMontageplanAffectedProjectDto>>): Array<WorkAdminMontageplanAffectedProjectDto> => r.body)
    );
  }

  /** Path part for operation `adminMontageplanControllerRecalculateStatus()` */
  static readonly AdminMontageplanControllerRecalculateStatusPath = '/v2/admin/montageplan/recalculate-status';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `adminMontageplanControllerRecalculateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminMontageplanControllerRecalculateStatus$Response(
    params: {
      body: WorkAdminMontageplanRecalculateDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkAdminMontageplanService.AdminMontageplanControllerRecalculateStatusPath, 'patch');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `adminMontageplanControllerRecalculateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  adminMontageplanControllerRecalculateStatus(
    params: {
      body: WorkAdminMontageplanRecalculateDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.adminMontageplanControllerRecalculateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
